module.exports = __webpack_public_path__ + "static/pinkcardifancy1-c077458bd84eb7ca5eaed43a28261413.jpeg";